import React from 'react';
import PropTypes from 'prop-types';

import FilterButton from 'components/search_sidebar/filter_button';

import { isPresent } from 'helpers/string_helpers';

import CompsPropertyFilterGroup from 'bundles/comps/index/filters/comps_property_filter_group';
import CompsAddressFilterGroup from 'bundles/comps/index/filters/comps_address_filter_group';

export default class Filters extends React.Component {

  static propTypes = {
    industrialFilter: PropTypes.object,
    propertyFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired
  }

  static defaultProps = {
    industrialFilter: {}
  }

  render() {
    return (
      <>
        {this.renderPropertyButton()}
        <CompsAddressFilterGroup />
      </>
    );
  }

  renderPropertyButton() {
    const {
      industrialFilter,
      propertyFilter,
      selectedAssetClasses,
      selectedBuildingClasses,
      selectedInvestmentTypes
    } = this.props;

    const propertyFiltersApplied = Object.keys(propertyFilter).some((key) => {
      if (key === "lotUnits") return false;
      return isPresent(propertyFilter[key]);
    });

    const booleanFilters = [
      "driveThroughAccess",
      "ready",
      "served"
    ];

    const industrialFiltersApplied = Object.keys(industrialFilter).some((key) => {
      if (booleanFilters.includes(key)) return industrialFilter[key] === true;
      return isPresent(industrialFilter[key]);
    });

    const filtersApplied = propertyFiltersApplied || industrialFiltersApplied
                          || selectedBuildingClasses.length > 0 || selectedAssetClasses.length > 0
                          || selectedInvestmentTypes.length > 0;
    return (
      <FilterButton
        filtersApplied={filtersApplied}
        label="Property & Building"
        name="property-filters-popover"
      >
        <CompsPropertyFilterGroup />
      </FilterButton>
    );
  }
}
